"use client";

import { useIntl } from "react-intl";

import { Image } from "@/components/atoms/Image";
import { Text } from "@/components/atoms/Text";

import { useTrustSectionSpacesCarouselList } from "./useTrustSectionSpacesCarouselList";

const SpacesCarousel = () => {
  const intl = useIntl();
  const items = useTrustSectionSpacesCarouselList();

  return (
    <div className="tw-overflow-x-auto tw-scroll-smooth tw-[scrollbar-width:none] [&::-webkit-scrollbar]:tw-hidden">
      <div className="tw-flex tw-gap-12">
        {items.map(
          ({
            id: spaceCarouselItemId,
            spaceCarouselItemLabel,
            spaceCarouselItemImageSrc,
          }) => (
            <div
              key={spaceCarouselItemId}
              className="tw-relative tw-shrink-0 tw-w-[278px] tw-h-[315px] tw-rounded-[4.5px] tw-overflow-hidden tw-select-none"
            >
              <Image
                src={spaceCarouselItemImageSrc}
                alt={intl.formatMessage({
                  defaultMessage: "Space card",
                })}
                className="tw-absolute tw-inset-0"
              />
              <div
                className="tw-absolute tw-inset-0"
                style={{
                  backgroundImage:
                    "linear-gradient(-0.498deg, rgba(0, 0, 0, 0.5) 0.278%, rgba(0, 0, 0, 0) 18.376%)",
                }}
              />
              <Text
                element="p"
                typeface="headline-1-m"
                className="tw-absolute tw-bottom-[15px] tw-left-[21px] tw-text-brand-white tw-whitespace-nowrap"
              >
                {spaceCarouselItemLabel}
              </Text>
            </div>
          ),
        )}
      </div>
    </div>
  );
};

export { SpacesCarousel };
